import { render, staticRenderFns } from "./StudyInfo.vue?vue&type=template&id=d0fa71c2&scoped=true&"
import script from "./StudyInfo.vue?vue&type=script&lang=js&"
export * from "./StudyInfo.vue?vue&type=script&lang=js&"
import style0 from "./StudyInfo.vue?vue&type=style&index=0&id=d0fa71c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fa71c2",
  null
  
)

export default component.exports